import React from 'react';
import { Link } from 'react-router-dom';
import { FaCommentDots } from 'react-icons/fa';
import { PiHandsClappingDuotone } from 'react-icons/pi';
import './style/blogcard.css';

const timeAgo = (ts) => {
  const s = Math.floor((Date.now() - new Date(ts)) / 1000);
  const m = Math.floor(s / 60), h = Math.floor(m / 60),
        d = Math.floor(h / 24), w = Math.floor(d / 7),
        mo = Math.floor(d / 30);
  if (mo > 0) return `${mo}mo`;
  if (w  > 0) return `${w}w`;
  if (d  > 0) return `${d}d`;
  if (h  > 0) return `${h}h`;
  if (m  > 0) return `${m}m`;
  return s <= 5 ? 'now' : `${s}s`;
};

const Blog = ({ blog }) => {
  const hasCover = blog.thumbnail && blog.thumbnail !== '#' && blog.thumbnail !== '';

  return (
    <Link to={`/blog/${blog.title}`} className="bc-card">

      {/* ── Thumbnail ── */}
      {hasCover ? (
        <div className="bc-thumb">
          <img src={blog.thumbnail} alt={blog.title} loading="lazy" />
        </div>
      ) : (
        <div className="bc-thumb bc-thumb-placeholder">
          <span className="bc-thumb-initial">
            {blog.title?.[0]?.toUpperCase() ?? 'B'}
          </span>
        </div>
      )}

      {/* ── Body ── */}
      <div className="bc-body">

        {/* Tags */}
        {blog.tags?.length > 0 && (
          <div className="bc-tags">
            {blog.tags.slice(0, 2).map(tag => (
              <span className="bc-tag" key={tag}>#{tag}</span>
            ))}
            {blog.tags.length > 2 && (
              <span className="bc-tag bc-tag-more">+{blog.tags.length - 2}</span>
            )}
          </div>
        )}

        {/* Title */}
        <h3 className="bc-title">{blog.title}</h3>

        {/* Author + time */}
        <div className="bc-meta">
          <span className="bc-author">{blog.authorName}</span>
          <span className="bc-dot">·</span>
          <span className="bc-time">{timeAgo(blog.createdAt)}</span>
        </div>
      </div>

      {/* ── Footer ── */}
      <div className="bc-footer">
        <div className="bc-stat">
          <PiHandsClappingDuotone className="bc-stat-icon bc-stat-clap" />
          <span>{blog.likeCount ?? 0}</span>
        </div>
        <div className="bc-stat">
          <FaCommentDots className="bc-stat-icon bc-stat-comment" />
          <span>{blog.commentCount ?? 0}</span>
        </div>
        <span className="bc-read-cta">Read →</span>
      </div>

    </Link>
  );
};

export default Blog;